import Accordion from '@/src/components/common/Accordion/Accordion.client'
export default Accordion
